import { ICommentsState } from './ICommentsState';

export const initialState: ICommentsState = {
  comments: undefined,
  toSkip: 0,
  toAdd: 0,
  pusherRequestDetails: undefined,
};
